<app-tab>
  <dx-data-grid
    id="fieldsCropsGridContainer"
    [dataSource]="fieldCropDs"
    [libGridDefault]="{ stateStorageKey: 'app-field-grid-v2' }"
    [libGridTitle]="{ text: 'Parcelles Culturales' }"
    [allowColumnResizing]="false"
    [columnHidingEnabled]="false"
    (onToolbarPreparing)="onToolbarPreparing($event)"
  >
    <dxi-column
      caption="ID"
      width="8%"
      dataField="id"
      sortOrder="desc"
      [allowEditing]="false"
      dataType="number"
    >
    </dxi-column>

    <dxi-column
      caption="Campagne"
      width="auto"
      dataField="campaign.name"
      [allowEditing]="false"
    >
    </dxi-column>

    <dxi-column
      caption="Nom"
      width="auto"
      [allowEditing]="false"
      dataField="name"
    >
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column caption="Culture" [allowEditing]="false" dataField="crop.name">
    </dxi-column>

    <dxi-column
      caption="Superficie Cultivée"
      width="8%"
      format="#0.## Ha"
      dataType="number"
      [allowEditing]="false"
      dataField="cadastral_area"
    >
    </dxi-column>

    <dxi-column
      caption="Couleur"
      width="auto"
      cellTemplate="colorTemplate"
      [allowSorting]="false"
      [allowFiltering]="false"
      [allowEditing]="false"
      dataField="color"
    >
      <div *dxTemplate="let cellInfo of 'colorTemplate'">
        <span
          style="width: 18px; height: 18px"
          class="block border border-solid border-gray-300 mx-2"
          [ngStyle]="{ backgroundColor: cellInfo.data.color || '#ffffff' }"
        ></span>
      </div>
      <dxo-form-item editorType="dxColorBox"></dxo-form-item>
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      caption="Irriguée?"
      width="auto"
      [showEditorAlways]="false"
      falseText="Bour"
      trueText="Irriguée"
      dataType="boolean"
      dataField="is_irrigated"
    >
      <dxo-form-item editorType="dxCheckBox"></dxo-form-item>
    </dxi-column>

    <dxi-column
      caption="Date Début"
      [allowEditing]="false"
      dataField="started_at"
      format="shortDate"
      dataType="date"
    >
    </dxi-column>

    <dxi-column
      caption="Date Fin Estimée"
      dataField="estimated_end_at"
      format="shortDate"
      dataType="date"
    >
    </dxi-column>

    <dxi-column
      caption="Date d'Archivage"
      [allowEditing]="false"
      dataField="archived_at"
      format="shortDate"
      dataType="date"
    >
    </dxi-column>

    <dxi-column
      caption="Description"
      [allowEditing]="false"
      width="8%"
      dataType="stringLength"
      dataField="description"
    >
      <dxo-form-item
        editorType="dxTextArea"
        [editorOptions]="{ height: 70 }"
      ></dxo-form-item>
      <dxi-validation-rule
        type="stringLength"
        [max]="255"
      ></dxi-validation-rule>
    </dxi-column>

    <dxi-column type="buttons" [width]="110">
      <dxi-button
        hint="Plan Parcellaires"
        icon="ld-plot-plan"
        [visible]="canEdit"
        [onClick]="openEditor"
      ></dxi-button>

      <dxi-button name="delete"></dxi-button>
    </dxi-column>

    <dxo-editing
      mode="batch"
      [allowDeleting]="canDelete"
      [allowUpdating]="canEdit"
      [allowAdding]="false"
      [selectTextOnEditStart]="true"
    >
    </dxo-editing>

    <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>

    <dxo-group-panel [visible]="false"></dxo-group-panel>

    <dxo-export
      [enabled]="true"
      fileName="liste-cutltures-parcellaires"
      [allowExportSelectedData]="true"
    ></dxo-export>

    <dxo-sorting mode="multiple"></dxo-sorting>

    <dxo-paging [pageSize]="25"></dxo-paging>

    <dxo-pager
      [showPageSizeSelector]="true"
      [allowedPageSizes]="[25, 50, 100]"
      [showInfo]="true"
    >
    </dxo-pager>

    <dxo-filter-row [visible]="true"></dxo-filter-row>

    <dxo-search-panel [visible]="true" [width]="240"></dxo-search-panel>

    <dxo-header-filter [visible]="true"></dxo-header-filter>

    <dxo-selection selectAllMode="page" mode="multiple"></dxo-selection>
  </dx-data-grid>
</app-tab>
